import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  InspectionStatus,
  type SearchableInspectionResponse,
} from '../../../shared/models';

@Component({
  selector: 'backoffice-inspection-status',
  templateUrl: './inspection-status.component.html',
  styleUrls: ['./inspection-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InspectionStatusComponent {
  @Input() inspection!: SearchableInspectionResponse;

  readonly statusList = InspectionStatus;
}
